// extracted by mini-css-extract-plugin
export default {"space":"styles_space__W-pOg"};